import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminTaxonomiesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('taxonomy');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
